import React from "react";
import PropTypes from "prop-types";

export default function CardHeader({ children, border = true }) {
  const cardHeaderClasses = (border && " border-b border-blueGray-300") || "";
  return (
    <div
      className={"bg-transparent first:rounded-t px-5 py-3" + cardHeaderClasses}
      style={{
        fontSize: "1.25rem",
        fontWeight: "600",
      }}
    >
      {children}
    </div>
  );
}

CardHeader.propTypes = {
  children: PropTypes.node,
  border: PropTypes.bool,
};
